import React, { useContext, useEffect } from 'react';

import '@fontsource/roboto';
import GameSelect from './GameSelect';
import { GameContext } from '../entities/GameContext';
import Individual from './Individual';
import Group from './Group'
import TeamScoreboard from './TeamScoreboard';
import Double from './Double';

function Home(props) {
    const { gameType, setCloud } = useContext(GameContext);

    useEffect(() => {
      setCloud(props.isCloud)
    })
    
    //console.log("Home gameType:", gameType)
    if (gameType === -1) {
        return (<GameSelect />);
    }else if (gameType === 0 ) {
        return (<Individual />);
    }else if (gameType === 1 ) {
      return (<Group />);
    }else if (gameType === 3 ) {
      return (<Double />);
    }else {
      return (<TeamScoreboard />);
    }
}

export default Home;